// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"549":"b402f9bc","597":"d1f89a4c","766":"85e13597","890":"efef9718"}[chunkId] + ".chunk.css";
};